export default __webpack_public_path__ + "static/media/google-pagespeed.51b2116c.svg";